import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { RadioGroup } from './styled';
var Radios = function (_a) {
    var _b = _a.options, options = _b === void 0 ? [] : _b, onChange = _a.onChange, _c = _a.value, value = _c === void 0 ? [] : _c;
    return (_jsx(RadioGroup, { options: options, onChange: function (e) { return onChange(e.target.value); }, value: value }));
};
export default Radios;
